var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "custom-field-label-pane__layer-field-pane" },
    [
      _c("PtVirtualTree", {
        staticClass: "custom-field-label-pane__layer-field-pane__list",
        attrs: {
          "item-class": "custom-field-label-pane__layer-field-pane__item",
          "item-min-item-size": 32,
          data: _vm.treeData,
          "default-expand-all": _vm.defaultExpandAll,
          "default-expand-keys": _vm.defaultExpandKeys,
          "auto-expand-parent": false,
          filter: _vm.filter,
          "filter-node-method": _vm.filterNodeMethod,
          "node-key": "id",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var node = ref.node
              var data = ref.data
              var isShowExpandIcon = ref.isShowExpandIcon
              var isExpand = ref.isExpand
              var toggleNodeExpand = ref.toggleNodeExpand
              return [
                _c(
                  "div",
                  {
                    style: {
                      paddingLeft: (node.level - 1) * 16 + "px",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.onCheckNode(node)
                      },
                    },
                  },
                  [
                    _c("PtIcon", {
                      class: {
                        active: _vm.checkedList.includes(data.id),
                      },
                      attrs: {
                        icon: _vm.checkedList.includes(data.id)
                          ? "SolidCheckboxOn"
                          : "SolidCheckboxOff",
                      },
                    }),
                    isShowExpandIcon
                      ? _c("PtIcon", {
                          staticClass:
                            "custom-field-label-pane__layer-field-pane__item__expand-icon",
                          attrs: {
                            icon: isExpand
                              ? "SolidDropdownOpen"
                              : "SolidDropdownRight",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.onToggleNodeExpand(
                                node,
                                toggleNodeExpand
                              )
                            },
                          },
                        })
                      : _c("PtIcon", {
                          staticClass:
                            "custom-field-label-pane__layer-field-pane__item__dot-icon",
                          attrs: { icon: "SolidSmallDot" },
                        }),
                    _c("div", {
                      staticClass:
                        "custom-field-label-pane__layer-field-pane__item__name",
                      attrs: { title: _vm.getNodeName(data.name) },
                      domProps: {
                        innerHTML: _vm._s(_vm.getNodeName(data.name)),
                      },
                    }),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "empty",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "custom-field-label-pane__option-field-pane__no-data",
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.filter
                            ? _vm.$t(
                                "PtCustomFieldLabelPane.editor.filter." +
                                  _vm.field.field_type +
                                  ".noFilterData"
                              )
                            : _vm.$t(
                                "PtCustomFieldLabelPane.editor.filter." +
                                  _vm.field.field_type +
                                  ".noData"
                              )
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }